import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class CropperScaffold extends Component {
  static defaultProps;
  render() {
    const { label, required, children } = this.props;

    const scaffoldClasses = {
      'input-scaffold': true,
      'cropper-scaffold': true,
      [`${this.props.className}`]: this.props.className,
    };

    return (
      <div className={classNames(scaffoldClasses)}>
        {label ? (
          <span className="input-label">
            {label}
            {!required ? <span className="input-label--optional">optional</span> : null}
          </span>
        ) : null}
        {children}
        {this.props.validation ? <div className="input-validation">{this.props.validation}</div> : null}
      </div>
    );
  }
}

CropperScaffold.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  required: PropTypes.bool,
  validation: PropTypes.any,
};

CropperScaffold.defaultProps = {
  children: null,
  className: null,
  label: null,
  validation: null,
};

export default CropperScaffold;



// WEBPACK FOOTER //
// ./src/common/forms/CropperScaffold.js